<template>
  <div class="total--card">
    <alertScreen
      :showAlertScreen="alertScreen"
      :alertTitle="`Ganhe ${normalizeReward} REAIS para cada site novo ativo`"
      :alertText="`Ao indicar um usuário para criar site Uli, você ganhará R$ ${this.$store.state.user.codes[0].reward} e ele ganhará ${normalizeDiscount} OFF na adesão do novo site. Veja mais detalhes no menu Afiliados`"
      :confirmText="`OK`"
      :hideCancel="true"
      @returnAlertScreen="alertScreen = false"
    />
    <div class="card--body">
      <div class="row justify-content-between align-items-center">
        <div class="col-7 pr-0 text-left">
          <p class="title--card">
            Seu cupom
            <br />
            <span v-if="discountValue >= 1">R$ {{normalizeDiscount}} OFF</span>
          </p>
        </div>
        <div class="col-5 pl-0 text-right">
          <img
            v-if="this.$store.state.application.class == 'uli'"
            class="logo--franchise"
            src="../../assets/img/uli-default.svg"
            :alt="this.$store.state.application.app_name"
          />
          <img
            v-else
            class="logo--franchise"
            src="../../assets/img/Icone-Sitejet-branco.svg"
            :alt="this.$store.state.application.app_name"
          />
        </div>
        <div class="col-12 text-left">
          <p
            class="reward--text"
            v-if="this.$store.state.user.codes[0].reward > 0"
            @click="alertScreen = true"
          >Ganhe R$ {{normalizeReward}} por indicação</p>
          <p class="cupom--highlight">
            <a
              :href="this.$store.state.user.codes[0].url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class>{{this.$store.state.user.codes[0].code}}</span>
            </a>
          </p>
          <p class="cupom--url" id="cupomUrl" @click="goToLink">
            <a
              :href="this.$store.state.user.codes[0].url"
              target="_blank"
              rel="noopener noreferrer"
            >{{this.$store.state.user.codes[0].url}}</a>
          </p>
          <b-popover
            :show.sync="show"
            :disabled.sync="show"
            :placement="'bottom'"
            target="cupomUrl"
          >Link Copiado</b-popover>
        </div>
        <div class="col-auto text-center buttons--options pr-0">
          <button class="btn" @click="copyLink">Copiar link</button>
        </div>
        <div class="col-auto text-center buttons--options pl-0">
          <a
            :href="`whatsapp://send?text=Use meu cupom e crie seu site com desconto! ${this.$store.state.user.codes[0].url}`"
          >
            <button class="btn">Enviar Whats</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertScreen from "@/components/molecules/AlertScreen";

export default {
  name: "CardMessageUli",
  data() {
    return {
      discountValue: 20,
      rewardValue: 150,
      show: false,
      alertScreen: false
    };
  },
  components: {
    alertScreen
  },
  computed: {
    normalizeDiscount() {
      let discount = this.$store.state.user.codes[0].discount;
      discount = discount.replace(".", ",");
      return discount;
    },
    normalizeReward() {
      let reward = this.$store.state.user.codes[0].reward;
      if (reward) {
        reward = reward.replace(".", ",");
        return reward;
      } else {
        return false;
      }
    }
  },
  methods: {
    goToLink() {
      setTimeout(() => {
        this.show = false;
      }, 500);
    },
    copyLink(e) {
      let success = null;
      if (e) {
        this.$copyText(this.$store.state.user.codes[0].url).then(
          function(e) {
            success = true;
          },
          function(e) {
            success = false;
          }
        );
        setTimeout(() => {
          if (success === true) {
            this.show = true;
          } else if (!success === false) {
            this.show = false;
          }
          setTimeout(() => {
            this.show = false;
          }, 500);
        }, 150);
      }
    }
  }
};
</script>

<style scoped>
.total--card {
  background-color: var(--main-color);
  background-image: url("../../assets/img/bg-message-card.svg");
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px;
}
.card--body {
  padding: 24px 22px;
  color: #ffffff;
}
.card--body .title--card {
  font-family: "Montserrat", sans-serif;
  font-size: 1.56rem;
  font-weight: 700;
  line-height: 1.86rem;
}
.card--body .logo--franchise {
  max-height: 60px;
  fill: white;
}
.card--body .reward--text {
  font-size: 1.12rem;
  cursor: pointer;
}
.card--body .cupom--highlight {
  margin: 29px 0;
}
.card--body .cupom--highlight span {
  border: 1px dashed #ffffff;
  padding: 12px 16px;
  text-transform: uppercase;
  font-weight: 700;
  cursor: pointer;
}
.card--body .buttons--options button {
  background-color: #fff;
  color: var(--main-color);
  font-size: 0.87rem;
  padding: 11px 26px;
  font-family: "Montserrat", sans-serif;
}
.card--body a {
  padding: 0px;
}
.card--body .cupom--url a,
.card--body .cupom--highlight a {
  color: #ffffff;
}
.card--body .cupom--url a:hover,
.card--body .cupom--highlight a:hover {
  color: #ffffff;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/CardMessageUli.vue